'use client';

import React, { useState } from 'react';
import Image, { getImageProps } from 'next/image';
import { useRouter } from 'next/navigation';

import { SvgIconWrapper, Typography, useMediaQueryBreakPointDown } from 'lighthouse';
import { ChevronLeftOffOutlineMdSVG } from 'lighthouse-icons';

import { copyToClipboard } from '@/utilities/copyToClipboard';
import { getStrapiImageUrl } from '@/utilities/strapiImageUrl';

import { BannerDetailModal } from './_components/BannerDetailModal';
import { SingleBannerProps } from './models';

import { cornbar } from 'cornbar';

export const SingleBanner = ({ contentData }: SingleBannerProps) => {
    const router = useRouter();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const isSmallScreen = useMediaQueryBreakPointDown();
    const shouldShowBanner =
        contentData.showIn === 'both' || (contentData.showIn === 'mobile' && isSmallScreen) || (contentData.showIn === 'desktop' && !isSmallScreen);

    const handleOnClickLink = async () => {
        if (contentData.actionType === 'LINK') {
            switch (contentData.linkTarget) {
                case 'NEW_TAB':
                    window.open(contentData.link || '', '_blank');
                    break;
                case 'COPY':
                    await copyToClipboard(contentData.link || '');
                    cornbar.show({
                        title: 'عملیات موفق بود',
                        description: `${contentData.link} کپی شد!`,
                        variant: 'success'
                    });
                    break;
                default:
                    void router.push(contentData.link || '', {});
                    break;
            }
        } else {
            setIsOpenModal(true);
        }
    };

    const sizeClassNames = {
        small: 'h-[78px] bg-cover bg-center px-4',
        medium: 'justify-center pb-4'
    } as const;

    if (!shouldShowBanner) {
        return null;
    }

    const backgroundImage =
        contentData.size === 'small'
            ? getImageProps({ src: getStrapiImageUrl(contentData.bannerBackground.url), width: 1200, height: 78, alt: '' }).props.src
            : undefined;

    return (
        <>
            <button
                onClick={handleOnClickLink}
                className={`all-unset my-4 flex w-full cursor-pointer items-center overflow-hidden rounded-lg bg-no-repeat shadow-elevation1
                    transition-all duration-300 hover:-translate-y-0.5 hover:shadow-elevation2 ${sizeClassNames[contentData.size]}`}
                style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : ''
                }}>
                {contentData.size === 'medium' && (
                    <Image
                        sizes='(max-width: 500px) 100vw, 500px'
                        src={getStrapiImageUrl(contentData.bannerBackground.url)}
                        height={214}
                        width={500}
                        alt='image'
                        className='h-auto w-full max-w-[500px] rounded-lg'
                    />
                )}
                {!contentData.onlyImage && (
                    <>
                        {contentData?.icon && <Image src={getStrapiImageUrl(contentData.icon.url)} height={38} width={38} alt='icon' />}
                        <Typography variant='subtitle1' color='white' className='pt-1' component='span'>
                            {contentData.title}
                        </Typography>
                        <SvgIconWrapper icon={ChevronLeftOffOutlineMdSVG} size='md' className='mr-auto' color='white' />
                    </>
                )}
            </button>
            {isOpenModal && <BannerDetailModal contentData={contentData} onClose={() => setIsOpenModal(false)} />}
        </>
    );
};
